import React, { useEffect } from 'react';
import { Button } from 'antd';
import OrderForm from './OrderForm';
import { ArrowLeftOutlined, EditOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@app/hooks/reduxHooks';
import { getOrder } from '@app/store/slices/orderSlice';
import PageHeader from '@app/components/common/PageHeader/PageHeader';

const EditOrder = () => {
  const { id: orderId } = useParams<{ id: string }>();

  const { record } = useAppSelector((state) => state.order);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (orderId) {
      dispatch(getOrder(Number(orderId)));
    }
  }, [orderId, dispatch]);

  if (!record) return null;

  return (
    <>
      <PageHeader
        icon={<EditOutlined />}
        title={`Sửa đơn ${record.order_code}`}
        subtitle="Cập nhật thông tin đơn hàng"
        extra={
          <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>
            Quay lại
          </Button>
        }
      />
      <OrderForm tabKey="1" record={record} />
    </>
  );
};

export default EditOrder;
